/**
 * Event args for KeyUp and KeyDown events.
*/
var IgrKeyEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrKeyEventArgs() {
    }
    Object.defineProperty(IgrKeyEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrKeyEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrKeyEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrKeyEventArgs.prototype, "alt", {
        /**
         * Gets a value indicating whether the ALT key was pressed.
        */
        get: function () {
            return this.i.alt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrKeyEventArgs.prototype, "ctrl", {
        /**
         * Gets a value indicating whether the CTRL key was pressed.
        */
        get: function () {
            return this.i.ctrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrKeyEventArgs.prototype, "keyCode", {
        /**
         * Gets the keyboard code for a KeyDown or KeyUp event.
        */
        get: function () {
            return this.i.keyCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrKeyEventArgs.prototype, "modifiers", {
        /**
         * Gets the modifier flags for a KeyDown or KeyUp event.
         * The flags indicate which combination of CTRL, SHIFT, and ALT keys was pressed.
        */
        get: function () {
            return this.i.modifiers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrKeyEventArgs.prototype, "shift", {
        /**
         * Gets a value indicating whether the SHIFT key was pressed.
        */
        get: function () {
            return this.i.shift;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrKeyEventArgs.prototype, "defaultPrevented", {
        /**
         * Gets whether the PreventDefault method was called.
        */
        get: function () {
            return this.i.defaultPrevented;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Tells the user agent that if the event does not get explicitly handled, its default action should not be taken as it normally would be.
    
    */
    IgrKeyEventArgs.prototype.preventDefault = function () {
        this.i.preventDefault();
    };
    /**
     * Prevent the event from bubbling up.
    
    */
    IgrKeyEventArgs.prototype.stopPropagation = function () {
        this.i.stopPropagation();
    };
    return IgrKeyEventArgs;
}());
export { IgrKeyEventArgs };
//# sourceMappingURL=igr-key-event-args.js.map
